import { render } from "./Weather3.vue?vue&type=template&id=525d5b22"
import script from "./Weather3.vue?vue&type=script&lang=js"
export * from "./Weather3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__